import { render, staticRenderFns } from "./AddressListTemplate.vue?vue&type=template&id=4a776a8a&"
import script from "./AddressListTemplate.vue?vue&type=script&lang=js&"
export * from "./AddressListTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports